import dayjs from 'dayjs';

import { AdminFunction, FunctionFlag } from '../types';

import {
  FunctionFlags,
  FunctionFormValues
} from '../components/form/CreateEditFunctionForm';
import { isNil, omit } from 'ramda';

export type FunctionGroupsResponse = {
  functionId: number;
  description: string;
};

export const convertFlagsObjectToArray = (flags: FunctionFlags): string[] => {
  return Object.keys(flags).filter((key) => flags[key] === true);
};

export const convertPayloadForSave = (
  data: FunctionFormValues
): AdminFunction => ({
  ...omit(['convertedFlags'], data),
  valid: {
    from: dayjs(data.valid.from).startOf('day').toISOString(),
    to: dayjs(data.valid.to).endOf('day').toISOString()
  },
  flags: convertFlagsObjectToArray(data.convertedFlags)
});

export const convertResponseToOptions = (
  response: FunctionGroupsResponse[] | undefined
) =>
  response
    ? response.map((data) => {
        return {
          label: data.description,
          value: data.functionId
        };
      })
    : [];

export const hasFlag = (
  currentFlag: FunctionFlag,
  rowData?: FunctionFormValues
) => {
  if (!isNil(rowData)) return rowData.flags.includes(currentFlag) ?? false;
  else return false;
};
